import type { ParsedUrlQueryInput } from 'querystring';

/** @deprecated just use URLSearchParams instances instead */
export const urlParamsToQueryObject = (urlParams: URLSearchParams): ParsedUrlQueryInput => {
  const queryObject: ParsedUrlQueryInput = {};

  urlParams.forEach((value, key) => {
    if (queryObject[key]) {
      if (!Array.isArray(queryObject[key])) {
        queryObject[key] = [queryObject[key] as string];
      }
      (queryObject[key] as string[]).push(value);
    } else {
      queryObject[key] = value;
    }
  });

  return queryObject;
};
